import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

// Returns the stored Audit (same shape as getTailoredAudits items) so callers can update their
// display immediately instead of waiting for the invalidation-driven refetch (FIQ-682)
export const createTailoredAuditReason = api(function createTailoredAuditReason(audit) {
    return mutate(
        gql`
            mutation CreateTailoredAuditReason($audit: JSONObject!) {
                createTailoredAuditReason(audit: $audit) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { audit },
        { returns: "createTailoredAuditReason" }
    )
})
